import React from 'react';
import { object, string } from 'prop-types';

import useStyles from 'hooks/useStyles';
import { COURSE_ALL_RATING_CLICK } from 'constants/gtmEvent';

import styles from './Review.scss';
import RatingComment from 'components/RatingComment';

const Review = ({ id, ratings, averageRate, ratingCount, elementRef }) => {
  useStyles(styles);

  return (
    <section className={styles.root} id={id} ref={elementRef}>
      <RatingComment
        ratings={ratings}
        averageRate={averageRate}
        ratingCount={ratingCount}
        ratingLimit={3}
        eventName={COURSE_ALL_RATING_CLICK}
      />
    </section>
  );
};

Review.propTypes = {
  id: string,
  ratings: string,
  averageRate: string,
  ratingCount: string,
  elementRef: object,
};

Review.defaultProps = {
  id: '',
  ratings: [],
  averageRate: 0,
  ratingCount: 0,
  elementRef: {},
};

export default Review;
